<template>
<div class="row justify-content-md-center">

	<div class="col-12 col-xl-8">

		<b-form @submit.prevent="submitForm('personEdit')"
		        class="mb-3">
			<action-buttons class="pull-right"
			                @save-and-back="submitFormAndBack"
			                @save-and-new="submitFormAndNew"
			                @back="goBack"
			                :disable-next="true"
			                :disable-previous="true"
			                :disable-delete="true">
			</action-buttons>

			<h1 class="display-4"
			    v-if="mode == 'edit'">Persoon aanpassen</h1>
			<h1 class="display-4"
			    v-if="mode == 'add'">Persoon toevoegen</h1>
			
			<h2 v-if="!isFetching && mode == 'edit'">{{ (form.last_name_prefix) ? `${form.first_name} ${form.last_name_prefix} ${form.last_name}` : `${form.first_name} ${form.last_name}` }}</h2>

			<partial-loader :loading="isFetching"></partial-loader>

			<div v-if="!isFetching">

				<b-alert v-if="formError"
				         show
				         variant="warning">
					<span v-for="errors in formError.errors">
							<span v-for="error in errors">{{ error }}<br /></span>
					</span>
				</b-alert>

				<div class="row">
					<div class="col-lg-6 col-md-12">
						<person-form-fields :hide-admin="false"
						                    :form.sync="form"
											:countryList="countryList"
											:mode="mode"></person-form-fields>
					</div>

					<div class="col-lg-6 col-md-12">

						<b-jumbotron class="py-4">

							<h3>Biednummers</h3>

							<b-form-group label="Vast biednummer:">
								<b-form-input type="text"
											  autocomplete="off"
								              v-model="form.fixed_bid_number">
								</b-form-input>
							</b-form-group>

							<h4>Biednummers per veiling</h4>

							<div v-if="mode == 'edit'">
								<bid-numbers></bid-numbers>
							</div>

							<b-alert v-if="mode == 'add'"
							         variant="warning"
							         show>
								Sla de persoon op om biednummers toe te voegen.
								<b-btn variant="primary"
								       size="sm"
								       @click="submitForm('personEdit')"><i class="fa fa-fw fa-save"></i> Sla direct op</b-btn>
							</b-alert>

						</b-jumbotron>

						<b-jumbotron class="py-4">
							
							<h3>E-maillogs</h3>

							<email-logs-component
								:isFetching="isFetching"
								:logs="person.email_logs"
							/>

						</b-jumbotron>

					</div>

				</div>

			</div>

		</b-form>

	</div>

</div>
</template>

<script>
import { isNil, pick, forOwn, keys, find } from 'lodash';
import PersonService from '@/services/person-service';
import PartialLoader from '@/components/elements/PartialLoader';
import { replaceEmptyByNull } from '@/helpers/object-helper';
import BidNumbers from './PersonBidNumbers';
import ActionButtons from '@/components/elements/Edit/ActionButtons';
import PersonFormFields from './PersonFormFields';
import { flashSuccess } from '@/helpers/flash-message-helper';
import EmailLogsComponent from '../../../elements/EmailLogsComponent';

export default {
	components: {
		PartialLoader,
		BidNumbers,
		ActionButtons,
		PersonFormFields,
		EmailLogsComponent
	},
	data() {
		return {
			isFetching: true,
			mode: 'add',
			countryList: [],
			person: {},
			form: {
				salutation: '',
				first_name: '',
				last_name_prefix: '',
				last_name: '',
				email: '',
				code: '',
				company: '',
				telephone: '',
				mobile: '',
				address: '',
				city: '',
				zipcode: '',
				country: '',
				is_admin: false,
				fixed_bid_number: '',
				bank_account_number: '',
				bank_account_name: '',
				bic: '',
				cash: false,
				invoice_emails: '',
				note: '',
				no_email: false,
			},
			formError: false,
			slugTitle: '',
		}
	},
	watch: {
		person() {
			//console.log(this.person);
			this.form = pick(this.person, keys(this.form));
			this.form.is_admin = find(this.person.user.roles, { name: 'admin' }) ? true : false;
			this.form.no_email = /^dummy{1}\d+\@{1}odb.auction$/.test(this.person.email);
			this.form.cash = this.person.cash == 1 ? true : false;

			/* The regex above matches 'dummy{one or more numbers}@odb.auction' */
		},
		'$route': 'initForm'
	},
	methods: {
		initForm() {
			if (!isNil(this.$route.params.personId)) {
				this.mode = 'edit';
				this.fetchPerson();
			} else {
				this.form = {
					country: 'NL',
					cash: false,
				};
				this.mode = 'add';
				this.fetchCountryList()
				.then(() => {
					this.isFetching = false;
				})
			}
		},
		isEmpty(value) {
			return isNil(value) || value.length == 0;
		},
		fetchPerson() {
			return PersonService.getOne(this.$route.params.personId)
				.then(response => {
					this.fetchCountryList();
					this.isFetching = false;
					this.person = response;
				}).catch(error => {
					this.isFetching = false;
					this.error = error.message;
				});
		},
		fetchCountryList() {
			return PersonService.getCountryList()
				.then(response => {
					let arr = [];

					for (var code in response) {
						let obj = {
							value: code,
							text: response[code]
						}

						arr.push(obj);
					}

					this.countryList = arr;
				})
				.catch(error => {
					this.isFetching = false;
					this.error = error.message;
				})
		},
		submitForm(action) {
			this.isFetching = true;
			this.formError = false;

			if (!this.form.bank_account_number)
				this.form.bank_account_name = null;

			if (!this.form.country || this.form.country == 'NL')
				this.form.bic = null;
					
			const post = replaceEmptyByNull(this.form);
			//console.log(post);

			if (this.mode == 'add') {
				return PersonService.create(post).then(response => {
					this.isFetching = false;
					flashSuccess(this.$t('person.createSuccess'), true);
					this.$router.push({ name: action, params: { personId: response.person.id } });
				}).catch(error => {
					this.isFetching = false;
					this.formError = error.response.data;
				});
			} else {
				return PersonService.update(this.$route.params.personId, post).then(response => {
					this.isFetching = false;

					flashSuccess(this.$t('person.updateSuccess'), (action != 'personEdit'));

					this.$router.push({ name: action });
				}).catch(error => {
					this.isFetching = false;
					this.formError = error.response.data;
				});
			}
		},
		submitFormAndBack() {
			this.submitForm('personList');
		},
		submitFormAndNew() {
			this.submitForm('personAdd');
		},
		goBack() {
			this.$router.push({ name: 'personList' });
		}
	},
	mounted() {
		this.initForm();
	}
}
</script>



// WEBPACK FOOTER //
// PersonForm.vue?4633fd30